// extracted by mini-css-extract-plugin
module.exports = {"figure":"random-quote_figure__5YGPq","illustration":"random-quote_illustration__qp3gi"};